export const ERROR_CODES = {
  // Core / backend
  AUTH_INVALID: 'AUTH_INVALID',
  HTTP_401: 'HTTP_401',
  HTTP_500: 'HTTP_500',
  JS_ERROR: 'JS_ERROR',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR',

  // Extended / UI or domain-specific
  AUTHENTICATION_ERROR: 'AUTHENTICATION_ERROR',
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  CONFLICT_ERROR: 'CONFLICT_ERROR',
  SERVER_ERROR: 'SERVER_ERROR',
  NETWORK_ERROR: 'NETWORK_ERROR',
  FORBIDDEN: 'FORBIDDEN',
  NOT_FOUND: 'NOT_FOUND',
  TIMEOUT: 'TIMEOUT',
  RATE_LIMITED: 'RATE_LIMITED',
  CANCELLED: 'CANCELLED',
} as const;

export type ErrorCode = (typeof ERROR_CODES)[keyof typeof ERROR_CODES];
